<script lang="ts">
  import { Validator, type ValidatorMessages } from "../../forms/validators";
  import type { ControlValidator } from "../../forms/validators";
  import FormField from "../../forms/FormField.svelte";
  import { Control, setupControl } from "../../forms/controls";
  import { setContext } from "svelte";

  export let title: string;
  // either set name and validators
  export let name: string = null;
  export let required: boolean = false;
  export let validators: ControlValidator[] = [];
  export let value: any[] = undefined;
  // ... or bind a control
  export let control: Control = null;
  export let standalone: boolean = false;
  export let displayName: string = undefined;
  export let errors: ValidatorMessages = undefined;

  const changes = setupControl(Control, {
    name,
    validators: [...validators, ...(required ? [Validator.required] : [])],
    value: value || [],
    control,
    standalone,
  });
  setContext("CheckboxGroup", changes);
  $: ctrl = $changes;

  let oldValue = value;
  $: if (value !== oldValue) {
    oldValue = value;
    ctrl.value = value || [];
  }
</script>

<FormField control={ctrl} displayName={displayName || title} {errors} {standalone} on:change>
  <div class="checkbox-group">
    <div class="title">{title}</div>
    <div class="checkbox-group-content">
      <slot value={Array.isArray(ctrl.value) ? ctrl.value : []} />
    </div>
  </div>
</FormField>

<style lang="scss">
  .checkbox-group {
    .title {
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 0.4em;
    }
  }

  .checkbox-group-content {
    position: relative;
  }
</style>
